<template>
  <div class="page-wrap">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>监控中心</el-breadcrumb-item>
			<el-breadcrumb-item class="linkpath" :to="{ path: '/ProductPandect'}">监控产品</el-breadcrumb-item>
      <el-breadcrumb-item class="linkpath">历史监控链接汇总</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page">
      <section class="content-warpper noticereview">
        <!-- 顶部查询框 -->
        <section class="seaerch-wrapper" style="padding:0; margin:0;overflow:unset;">
          <el-form :model="searchform" class="search-form" label-position="left" :label-width="formLabelWidth">
           	<el-form-item label="监控平台">
              <el-select v-model="searchform.platform" placeholder="请选择平台" size="small">
								<el-option :value="null" label="全部"></el-option>
                <el-option
                  v-for="item in plateList"
                  :key="item.dictCode"
                  v-show="item.pricename=='main'"
                  :value="item.dictCode"
                  :label="item.dictName"
                ></el-option>
              </el-select>
            </el-form-item>
						<el-form-item label="商品名称">
              <el-input v-model="searchform.itemtitle" autocomplete="on" placeholder="请填写商品名称"  size="small" clearable></el-input>
            </el-form-item>
						<el-form-item label="店铺名称">
              <el-input v-model="searchform.shopname" autocomplete="on" placeholder="请填写店铺名称" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="店铺性质"  v-if="!isMore">
              <el-select v-model="searchform.shoptype" placeholder="请选择平台" size="small">
								<el-option :value="null" label="全部"></el-option>
								<el-option :value="1" label="授权店铺"></el-option>
								<el-option :value="2" label="非授权店铺"></el-option>
              </el-select>
            </el-form-item>
						<el-form-item></el-form-item>
            <el-form-item class="isMoreBtn">
              <span class="more-text" @click="isMore = !isMore">
								{{isMore ? '点击展开更多' : '点击收起'}}
								<i :class="isMore?'el-icon-arrow-down':'el-icon-arrow-up'"></i>
							</span>
              <el-button size="small" style="letter-spacing: 6px;padding-right: 6px;" @click="queryTable()">查询</el-button>
            </el-form-item>
          </el-form>
        </section>
				<!-- 表格部分 -->
				<LinkSummaryList ref="LinkSummaryList" :searchform="searchform"/>
      </section>
    </div>
  </div>
</template>

<script>
import LinkSummaryList from "./linkSummaryList";
import { fetchGet } from "@/libs/reqCommon";
import { mapGetters, mapActions } from "vuex";
export default {
  components: { LinkSummaryList },
  data() {
    return {
			formLabelWidth: "80px",
			searchform: {
				platform:null,
				shoptype:null
			},
      isMore: true,
    };
  },
  computed: {
    ...mapGetters(["plateList"])
  },
  created() {
    this.reqPlateList();
	},
  methods: {
		...mapActions(["reqPlateList"]),
		queryTable(){
			this.$refs.LinkSummaryList.load();
		}
  }
};
</script>

<style lang="scss">
$highColor: #108cee;
.more-text {
  cursor: pointer;
  padding: 0 20px;
  color: $highColor;
}
.info-modal {
  .el-icon-warning {
    color: #f9bb63;
    font-size: 24px;
    line-height: 70px;
    &.cas {
      line-height: 50px;
    }
  }
  .content {
    width: calc(100% - 40px);
    float: right;
  }
  .red {
    color: red;
    margin: 0 0 10px 0;
  }
}

.isMoreBtn{
	  text-align: right;
    position: absolute;
    right: 0;
    top: 45px;
    z-index: 9;
}

</style>